'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import Container from '@/components/@base/container';

import StoreBanner from '../store-banner';
import { storeListQueryOptions } from '../../services/hooks';

export default function StoreHeader({ store }: { store: string }) {
  const { data: response } = useSuspenseQuery(storeListQueryOptions(store, 1));
  const { payload: storeData } = response;

  return (
    <Container className='mt-0 flex w-full md:mt-10'>
      {storeData && (
        <StoreBanner
          cover={storeData.cover}
          logo={storeData.logo}
          medals={storeData.medals}
          name={storeData.name}
          slogan={storeData.slogan}
        />
      )}
    </Container>
  );
}
